import { NFT, Premium, Pump, Terminal } from '../model/platform-tokens'

import type { Platform } from '../model/platform-tokens'

type PlatformSquareColors = {
  border: [string, string]
  gradients: [string, string, string, string]
  background: [string, string]
  outlinedGradient: [string, string]
}

type PlatformCircleColors = {
  gradients: [string, string, string, string]
}

export const PLATFORM_COLORS: Record<
  Platform,
  { square: PlatformSquareColors; circle: PlatformCircleColors }
> = {
  // kol.trade: the yellow accent into a dark bronze, so the white glyph on
  // the tile still reads. Was the Deluge blue.
  [Terminal]: {
    square: {
      border: ['#FFE38A', '#8A6400'],
      gradients: ['#8A6400', '#B58500', '#E5AE00', '#FFD23F'],
      background: ['#E5AE00', '#7A5800'],
      outlinedGradient: ['#B58500', '#FFD23F'],
    },
    circle: {
      gradients: ['#8A6400', '#FFE38A', '#FFE38A', '#B58500'],
    },
  },
  [Premium]: {
    square: {
      border: ['#8078B4', '#4A5ED9'],
      gradients: ['#4968FE', '#566FFE', '#A292FB', '#CDBBFF'],
      background: ['#B1ABDC', '#465EF1'],
      outlinedGradient: ['#B1ABDC', '#465EF1'],
    },
    circle: {
      gradients: ['#000DFF', '#00C8FF', '#07C9FF', '#002FFF'],
    },
  },
  [Pump]: {
    square: {
      border: ['#E49AFF', '#AC39AC'],
      gradients: ['#5731C9', '#FDABFF', '#FDABFF', '#5472DC'],
      background: ['#E7A3FF', '#432DD7'],
      outlinedGradient: ['#E7A3FF', '#432DD7'],
    },
    circle: {
      gradients: ['#5472DC', '#FDABFF', '#FDABFF', '#5731C9'],
    },
  },
  [NFT]: {
    square: {
      border: ['#2FB68E', '#2361B0'],
      gradients: ['#347DE1', '#3BFFEB', '#3BFFC1', '#0900B0'],
      background: ['#4FD6AE', '#2362AF'],
      outlinedGradient: ['#4FD6AE', '#2362AF'],
    },
    circle: {
      gradients: ['#5472DC', '#FDABFF', '#FDABFF', '#5731C9'],
    },
  },
}

export const PLATFORM_SQUARE_COLOR_MAP: Record<Platform, PlatformSquareColors> =
  {
    [Terminal]: PLATFORM_COLORS[Terminal].square,
    [Premium]: PLATFORM_COLORS[Premium].square,
    [Pump]: PLATFORM_COLORS[Pump].square,
    [NFT]: PLATFORM_COLORS[NFT].square,
  }

export const PLATFORM_CIRCLE_COLOR_MAP: Record<Platform, PlatformCircleColors> =
  {
    [Terminal]: PLATFORM_COLORS[Terminal].circle,
    [Premium]: PLATFORM_COLORS[Premium].circle,
    [Pump]: PLATFORM_COLORS[Pump].circle,
    [NFT]: PLATFORM_COLORS[NFT].circle,
  }
